// import httpClient from 'httpClient'
import { mapGetters } from 'vuex'
// import $ from 'jquery'

export default {
  name: 'Setting',
  data: () => {
    return {
      dismissSecs: 4,
      dismissCountDownSuccess: 0,
      dismissCountDownDanger: 0,
      errors: [],
      successMessage: ''
    }
  },
  computed: mapGetters([
    'isLogged'
  ]),
  methods: {
    countDownChangedSuccess (dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },

    countDownChangedDanger (dismissCountDownDanger) {
      this.dismissCountDownDanger = dismissCountDownDanger
    },

    showSuccess () {
      this.dismissCountDownSuccess = this.dismissSecs
    },

    showError () {
      this.dismissCountDownDanger = this.dismissSecs
    }
  }
}
